import React, { useCallback, forwardRef } from 'react';
import useLazyLoad from './useLazyLoad';

const defaultImage = '/images/placeholder_profile.png';
const feedDefaultImage = "/images/no-data-found/feed_dummy.png";

const LazyImage = forwardRef(({ src, alt }, ref) => {
  const [elementRef, isVisible] = useLazyLoad({ threshold: 0.1 });
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  return (
    <div ref={ref || elementRef} className="image">
      {isVisible && (
        <img
          src={src || defaultImage}
          onError={handleImageError}
          alt={alt}
          width="100%"
          style={{ opacity: '1', borderRadius: '100%' }}
        />
      )}
    </div>
  );
});

const LazyVideo = forwardRef(({ src, poster }, ref) => {
  const [elementRef, isVisible] = useLazyLoad({ threshold: 0.1 });

  return (
    <div ref={ref || elementRef}>
      {isVisible && (
        <video
          poster={poster}
          controls={true}
          x-webkit-airplay="allow"
          style={{ width: '100%', height: '100%' }}
        >
          <source src={src} type="video/mp4" />
        </video>
      )}
    </div>
  );
});


const LazySliderImage = forwardRef(({ src, alt, index  }, ref) => {
  const [elementRef, isVisible] = useLazyLoad({ threshold: 0.1, batchSize: 15 });
  const handleFeedImageError = useCallback((event) => {
    event.target.src = feedDefaultImage;
  }, []);

  return (
    <div ref={ref || elementRef} className="image">
      {isVisible && (
        <img
          src={src || defaultImage}
          onError={handleFeedImageError}
          alt={alt}
          width="100%"
          style={{ opacity: '1' }}
        />
      )}
    </div>
  );
});

const LazySliderVideo = forwardRef(({ src, poster, index  }, ref) => {
  const [elementRef, isVisible] = useLazyLoad({ threshold: 0.1, batchSize: 15});

  return (
    <div ref={ref || elementRef}>
      {isVisible && (
        <video
          poster={poster}
          controls={true}
          x-webkit-airplay="allow"
          style={{ width: '100%', height: '100%' }}
        >
          <source src={src} type="video/mp4" />
        </video>
      )}
    </div>
  );
});


export { LazyImage, LazyVideo, LazySliderImage, LazySliderVideo };






